import { Component, EventEmitter, Output } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './../i18n/en.json';
import spanish from './../i18n/es.json';
import portuguese from './../i18n/pt.json';

@Component({
  templateUrl: './indication-pop-up.component.html',
  styleUrls: ['./indication-pop-up.component.scss']
})
export class IndicationPopUpComponent {
  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  @Output() public popUpClosed = new EventEmitter<void>();


  closePopup(): void {
    this.popUpClosed.emit();
  }
}
